import './make-built-in.mjs';
import './object-define-property.mjs';
import { m as makeBuiltIn$1 } from '../../../../../../_virtual/make-built-in.mjs';
import { __exports as objectDefineProperty } from '../../../../../../_virtual/object-define-property.mjs';

var makeBuiltIn = makeBuiltIn$1.exports;
var defineProperty = objectDefineProperty;

var defineBuiltInAccessor = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

export { defineBuiltInAccessor as default };
